/** Derived summaries for the advanced-filter disclosure. */

import type { ScreenerFilterState } from "../../lib/types";
import { FILTER_CONTROL_CONFIG } from "./filter-control-config";

function hasValue(value: number | null): boolean {
  return value !== null;
}

function hasRange(minimum: number | null, maximum: number | null): boolean {
  return hasValue(minimum) || hasValue(maximum);
}

/** Counts active advanced concepts directly from the controlled filter state. */
export function countActiveAdvancedFilters(filters: ScreenerFilterState): number {
  return [
    filters.tradeDateFrom !== null || filters.tradeDateTo !== null,
    filters.minDistinctInsiders !== null,
    filters.exchanges.length > 0,
    filters.transactionActivities.length > 0,
    filters.transactionCodes.length > 0,
    filters.securityStatuses.length > 0,
    hasRange(filters.minShares, filters.maxShares),
    hasRange(filters.minPrice, filters.maxPrice),
    hasRange(filters.minHoldingsChange, filters.maxHoldingsChange),
    filters.confidences.length > 0,
    filters.amendmentStates.length > 0,
    filters.valueQualities.length > 0,
    filters.missingFieldFlags.length > 0,
    filters.industryDescription.trim() !== "",
    hasRange(filters.minFilingLagDays, filters.maxFilingLagDays),
    filters.accessionNumber.trim() !== "",
    filters.planStatuses.length > 0,
    filters.relationshipFlags.length > 0,
    filters.favoritesOnly,
    filters.marketCapBuckets.length > 0,
    hasValue(filters.minValueToMarketCapBps)
  ].filter(Boolean).length;
}

/** Describes an enforced security filter without duplicating filter state. */
export function describeSecurityFilter(filters: ScreenerFilterState): string | null {
  if (filters.securityStatuses.length === 0) return null;
  const labels = filters.securityStatuses.map(
    (status) =>
      FILTER_CONTROL_CONFIG.securityStatuses.find((option) => option.value === status)?.label ?? status
  );
  return labels.length === 1 ? (labels[0] ?? null) : `${labels.length} selected`;
}
